import { FC } from 'react';
import { EmptyStateFind } from 'ui/illustrations';

import { CaptionText, GeneralErrorContainer, GoalsLink, MainText } from './Errors.styled';
import { GENERAL_ERROR, TEST_IDS } from '../../constants';

export type GeneralErrorProps = {
  mainText?: string;
  id?: string;
};

export const GeneralError: FC<React.PropsWithChildren<GeneralErrorProps>> = ({
  mainText = GENERAL_ERROR,
  id = TEST_IDS.GeneralError,
  children,
}) => {
  return (
    <GeneralErrorContainer data-test={id}>
      <EmptyStateFind viewBox="0 0 297 250" />
      <MainText>{mainText}</MainText>
      {children && <CaptionText>{children}</CaptionText>}
      <GoalsLink to="/predictive-audiences">Back to all Predictive Goals</GoalsLink>
    </GeneralErrorContainer>
  );
};
